// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"d9288608","165":"f7d7c90f","515":"24e71c7f","796":"7f83263d"}[chunkId] + ".chunk.js";
};